import { createSlice } from "@reduxjs/toolkit";
import { AppraisalState } from "./appraisalTypes";
import {
  createSelfappraisal,
  updateAppraisal,
  deleteappraisal,
  fetchAllappraisal,
  fetchappraisalById,
} from "./appraisalAction";

const initialState: AppraisalState = {
  appraisal: [],
  selectedappraisal: undefined,
  loadingStates: {
    create: false,
    update: false,
    delete: false,
    fetchById: false,
    fetchAll: false,
  },
  errors: {
    create: undefined,
    update: undefined,
    delete: undefined,
    fetchById: undefined,
    fetchAll: undefined,
  },
};

const appraisalSlice = createSlice({
  name: "appraisal",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createSelfappraisal.pending, (state) => {
        state.loadingStates.create = true;
        state.errors.create = undefined;
      })
      .addCase(createSelfappraisal.fulfilled, (state, action) => {
        state.loadingStates.create = false;
        state.appraisal.push(action.payload);
      })
      .addCase(createSelfappraisal.rejected, (state, action) => {
        state.loadingStates.create = false;
        state.errors.create = action.payload as string;
      })

     
      .addCase(updateAppraisal.pending, (state) => {
        state.loadingStates.update = true;
        state.errors.update = undefined;
      })
      .addCase(updateAppraisal.fulfilled, (state, action) => {
        state.loadingStates.update = false;
        const index = state.appraisal.findIndex(
          (d: any) => d.Id === action.payload.Id
        );
        if (index !== -1) {
          state.appraisal[index] = action.payload;
        }
      })
      .addCase(updateAppraisal.rejected, (state, action) => {
        state.loadingStates.update = false;
        state.errors.update = action.payload as string;
      })

     
      .addCase(deleteappraisal.pending, (state) => {
        state.loadingStates.delete = true;
        state.errors.delete = undefined;
      })
      .addCase(deleteappraisal.fulfilled, (state, action) => {
        state.loadingStates.delete = false;
        state.appraisal = state.appraisal.filter(
          (d: any) => d.Id !== action.payload
        );
      })
      .addCase(deleteappraisal.rejected, (state, action) => {
        state.loadingStates.delete = false;
        state.errors.delete = action.payload as string;
      })

      
      .addCase(fetchappraisalById.pending, (state) => {
        state.loadingStates.fetchById = true;
        state.errors.fetchById = undefined;
      })
      .addCase(fetchappraisalById.fulfilled, (state, action) => {
        state.loadingStates.fetchById = false;
        state.selectedappraisal = action.payload;
      })
      .addCase(fetchappraisalById.rejected, (state, action) => {
        state.loadingStates.fetchById = false;
        state.errors.fetchById = action.payload as string;
      })

     
      .addCase(fetchAllappraisal.pending, (state) => {
        state.loadingStates.fetchAll = true;
        state.errors.fetchAll = undefined;
      })
      .addCase(fetchAllappraisal.fulfilled, (state, action) => {
        state.loadingStates.fetchAll = false;
        state.appraisal = action.payload.data;
      })
      .addCase(fetchAllappraisal.rejected, (state, action) => {
        state.loadingStates.fetchAll = false;
        state.errors.fetchAll = action.payload as string;
      });
  },
});

export default appraisalSlice.reducer;
